<template>
  <div>

    <b-field label="Name">
      <b-input v-model="name" :required="true" ref="autofocus"></b-input>
    </b-field>

    <b-field label="Typ">
      <b-select v-model="signType" placeholder="Auswählen" required :loading="false" icon="web">
        <option v-for="option in options.signTypes" :value="option" :key="option.id">
          {{ option.name }} (ID: {{option.id}})
        </option>
      </b-select>
    </b-field>

    <b-field label="Messe">
      <b-select v-model="exhibition" placeholder="Auswählen" required :loading="exhibitions.isLoading" icon="date_range">
        <option v-for="exhibition in options.exhibitions" :value="exhibition" :key="exhibition.id">
          {{ exhibition.name }} {{ exhibition.location }}
          <span v-if="exhibition.startDate && exhibition.endDate">({{exhibition.startDate | moment('DD.MM')}} – {{exhibition.endDate | moment('DD.MM.YYYY')}})</span>
        </option>
      </b-select>
    </b-field>

    <b-field label="Anmerkungen">
      <b-input type="textarea" v-model="comment" placeholder="Optional"></b-input>
    </b-field>

    <div :style="{'text-align': 'right'}">
      <button type="button" class="button is-success" :disabled="!isValidForm" @click="onConfirm(false)">Erstellen</button>
      <button type="button" class="button is-info" :disabled="!isValidForm" @click="onConfirm(true)">Erstellen & bearbeiten</button>
      <button type="button" class="button is-danger" @click="closeModals">Abbrechen</button>
    </div>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import { fetchExhibitions } from '@/store/modules/exhibitions'
import { saveSign } from '@/store/modules/sign'
import { fetchSignTypes } from '@/store/modules/sign-types'
import { closeModals } from '@/store/modules/modals'
import routes from '@/mixins/routes'
import router from '@/router'

import modals from '@/mixins/modals'

export default {
  name: 'ima-variant-modal',
  data () {
    return {
      name: '',
      comment: '',
      signType: null,
      exhibition: null
    }
  },
  computed: {
    ...mapState(['exhibitions', 'signTypes']),
    isValidForm () {
      return !!this.name.length && this.signType && this.exhibition
    },
    options () {
      return {
        exhibitions: this.exhibitions.data,
        signTypes: this.signTypes.data
      }
    }
  },
  mixins: [modals, routes],
  methods: {
    ...mapActions([fetchExhibitions, fetchSignTypes, saveSign]),
    ...mapMutations([closeModals]),
    onConfirm (editAfterCreation) {
      const { name, comment, signType, exhibition } = this
      const sign = {
        name,
        comment,
        signTypeId: signType.id,
        exhibitionId: exhibition.id
      }
      this.saveSign(sign).then(sign => {
        this.closeModals()
        if (editAfterCreation) {
          router.push({
            name: this.routes.SIGN_DETAILS,
            params: { id: sign.id }
          })
        }
      })
    }
  },
  created () {
    this.fetchExhibitions()
    this.fetchSignTypes()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/SignModal.vue